import { IconProps } from "../types";

export const UserListIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M1.5 13.432V7.2577C1.5 5.91126 2.29675 5.18969 3.77642 5.18969H13.2236C14.6951 5.18969 15.5 5.91126 15.5 7.2577V13.432C15.5 14.771 14.6951 15.5 13.2236 15.5H3.77642C2.29675 15.5 1.5 14.771 1.5 13.432ZM4.20732 3.24814H12.8008C13.5569 3.24814 13.8984 3.60521 13.9878 4.20032H3.02033C3.10163 3.60521 3.45935 3.24814 4.20732 3.24814ZM4.89837 14.0345C5.49187 12.9485 6.88211 12.2194 8.50813 12.2194C10.1341 12.2194 11.5163 12.941 12.1179 14.0345H13.0691C13.6057 14.0345 13.9065 13.7891 13.9065 13.2609V7.4288C13.9065 6.90064 13.6057 6.64772 13.0691 6.64772H3.93902C3.39431 6.64772 3.10163 6.90064 3.10163 7.4288V13.2609C3.10163 13.7891 3.39431 14.0345 3.93902 14.0345H4.89837ZM5.42683 1.5H11.5813C12.2398 1.5 12.6301 1.81987 12.6707 2.37779H4.32927C4.38618 1.81243 4.76829 1.5 5.42683 1.5ZM6.5 9.41498C6.5 8.33634 7.38618 7.43624 8.50813 7.43624C9.63008 7.43624 10.5163 8.33634 10.5163 9.41498C10.5163 10.4936 9.64634 11.4309 8.50813 11.4235C7.36992 11.4235 6.5 10.5457 6.5 9.41498Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
